import "./ploud.css";
import "@melloware/coloris/dist/coloris.css";
import Coloris from "@melloware/coloris";
import registry from "@patternslib/patternslib/src/core/registry";
import "./calendar/pattern";
import "./multiselection/pattern";
import "./focalpoint/pattern";

Coloris.init();
registry.init();